

import React from 'react';
import heartshape1 from '../../assets/img/shape/heart-shape1.png';
import about_2_1 from '../../assets/img/normal/about_2_1.png';
import about_2_2 from '../../assets/img/normal/about_2_2.png';
import about_2_3 from '../../assets/img/normal/about_2_3.png';


import about_2_3mask from '../../assets/img/normal/about_2_3-mask.png';

import about_shape2_1 from '../../assets/img/icon/heart-icon.svg';

import about_shape2_2 from '../../assets/img/icon/heart-icon.svg';


import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';
import banner1 from '../../images/banner1.jpg';
import banner2 from '../../images/banner2.jpg';
import banner3 from '../../images/banner3.jpg';
import banner4 from '../../images/banner4.jpg';










const AboutArea = () => {
  return (
    <>






















<div className="overflow-hidden space" id="about-sec">
<div
  className="shape-mockup about-bg-shape2-1 jump-reverse"
  data-top="10%"
  data-right="5%"
>
  <img src={heartshape1} alt="shape" />
</div>
<div className="container">
  <div className="row gx-60 gy-60 align-items-center">
    <div className="col-xl-6 col-lg-10">
      <div className="img-box2">
        <div className="img1">
          <img src={about_2_1} alt="About" />
        </div>
        <div className="img2 jump">
          <img src={about_2_2} alt="About" />
        </div>
        <div
          className="img3 moving"
          data-mask-src={about_2_3mask}
        >
          <img
            data-mask-src={about_2_3mask}
            src={about_2_3}
            alt="About"
          />
        </div>
        <div className="about-shape2-1 jump">
          <div className="color-masking">
            {/* <div
              className="masking-src"
              data-mask-src={about_shape2_1}
            /> */}
            {/* <img src={about_shape2_1} alt="img" /> */}
          </div>
        </div>
        <div className="about-shape2-2 jump-reverse">
          <div className="color-masking2">
            {/* <div
              className="masking-src"
              data-mask-src={about_shape2_2}
            />
            <img src={about_shape2_2} alt="img" /> */}
          </div>
        </div>
      </div>
    </div>
    <div className="col-xl-6">
      <div className="about-wrap2">
        <div className="title-area mb-35">
          {/* <span className="sub-title after-none before-none">
            Welcome to Donet Charity
          </span> */}
          <h2 className="sec-title">
          Gram seva Trust
          </h2>
          <p className="mt-30">
          Gram seva turst Organization is work from 20+ years
           which work on social development of rural and tribes and various 
           sector like Agriculture ,livelihood environmental
           awarness,education,nursery plantation etc.
          </p>
        </div>
        <div className="about-feature-grid">
        
          <div className="media-body">
            <h4 className="box-title">
            <img src={about_shape2_1} alt="img" />
              MISSION</h4>
            <p className="box-text">
            To develop a model to increase income
 and generate employment at the grass
 root level by an equitable and holistic
 development

            </p>
          </div>
        </div>
        <div className="about-feature-grid">
          {/* <div className="box-icon">
            <img src="assets/img/icon/about-icon2-2.svg" alt="icon" />
          </div> */}
          <div className="media-body">
            <h4 className="box-title">
            <img src={about_shape2_2} alt="img" />
              VISION </h4>
            <p className="box-text">
            Professionalizing the informal trade channel 
of fresh farm produce and creating gainful, dignified
 self- employment for the families dependent on 
agriculture sector. Designing holistic intervention
 models in the poor communities improving their 
Health, Education, Agriculture, and Livelihoods

            </p>
          </div>
        </div>
        <div className="btn-wrap mt-40">
          <a href="/about" className="th-btn">
            About More
            <i className="fas fa-arrow-up-right ms-2" />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
 
    </>
  );
};

export default AboutArea;









